import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { BannerComponent } from './components/banner/banner.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [FooterComponent, BannerComponent],
  exports: [FooterComponent, BannerComponent],
  imports: [RouterModule, NgbModule, CommonModule, FormsModule, SharedModule, FGBSharedModule],
})
export class LayoutModule {}
